import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import {
    ArticleValidationProcessStatus,
    DossierArticleWithInvoice,
    useDossierProcesses,
} from '@europrocurement/l2d-modules';
import { Box } from '@mui/material';
import React from 'react';
import DossierArticleProcessStatus from '../DossierArticleProcessStatus/DossierArticleProcessStatus';

type DossierProcessesTabTitleProps = {
    dossier: DossierOpenSearch;
    category: {
        id: number;
        label: string;
        validatorTypeId: number;
        checked: boolean;
    };
    dossierArticles: DossierArticleWithInvoice[];
};
const DossierProcessesTabTitle: React.FunctionComponent<DossierProcessesTabTitleProps> = function ({
    dossier,
    category,
    dossierArticles,
}) {
    const { getArticleProcessesStatus, getArticleProcessesStatusLabel } = useDossierProcesses();

    const status = getArticleProcessesStatus(
        dossier,
        category.validatorTypeId,
        dossierArticles.map((a) => a.id),
    );

    const statusLabel = getArticleProcessesStatusLabel(status);

    const articleStatusToFlag = (sts: ArticleValidationProcessStatus): number => {
        const map: Record<string, number> = {
            done: 400,
            ongoing: 200,
            failed: 500,
            pending: 100,
            'to-link': 100,
        };
        return map[sts] ?? 100;
    };
    // label: string, statusFlag: number, statusLabel: string

    return (
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {category.label}
            {statusLabel && (
                <DossierArticleProcessStatus
                    statusFlag={articleStatusToFlag(status)}
                    statusLabel={statusLabel}
                />
            )}
        </Box>
    );
};

export default DossierProcessesTabTitle;
